import { render } from "./AutoPost.vue?vue&type=template&id=20e10e10&scoped=true"
import script from "./AutoPost.vue?vue&type=script&lang=js"
export * from "./AutoPost.vue?vue&type=script&lang=js"

import "./AutoPost.vue?vue&type=style&index=0&id=20e10e10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e10e10"]])

export default __exports__